import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Gallery from "../../components/Gallery/Gallery";
import { images } from "../../assets/divider-images";
import Lightbox from "yet-another-react-lightbox";
import React, { useState } from "react";
const Divider = () => {

    const slides = images.map(({ src, width, height }) => ({
        src: src,
        width,
        height,
      }));
        
    const [visibleItems, setVisibleItems] = useState(12);
    
    const loadMore = () => {
        setVisibleItems((prevVisibleItems) => prevVisibleItems + 12);
    };
    const [index, setIndex] = useState(-1);

    const handleClick = (index, item) => setIndex(index);

    return (
        <main className="flex flex-1 flex-col">
            <Navbar/>
            <div className="mx-auto max-w-7xl px-4 text-center sm:px-8">
                <h1 className="page-heading">Here's some of our Nikkah Dividers!</h1>
                <div>
                    <Gallery
                        onClick={handleClick}
                        images={images.slice(0, visibleItems)}
                    />
                    {visibleItems < images.length && (
                        <button onClick={loadMore} className="btn-dark">
                        Load More
                        </button>
                    )}
                </div>
            </div>
                    <Lightbox
                        index={index}
                        open={index >= 0}
                        close={() => setIndex(-1)}
                        slides={slides}
                    />
            <Footer/>
        </main>
    )
}

export default Divider;